export default function SvgPlay(props) {
    return (
        <svg {...props} viewBox="0 0 29 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.39074 2.65726L26.0349 17.9825C27.7382 19.3826 27.7382 21.99 26.0349 23.3901L7.39074 38.7153C5.10687 40.5926 1.66825 38.9679 1.66825 36.0115L1.66825 5.36106C1.66825 2.40465 5.10687 0.779952 7.39074 2.65726Z"
                stroke="currentColor" strokeWidth="3"/>
        </svg>
    )
}